import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import {
  Grid,
  Button,
  Form,
  Feed,
  Card,
  Message,
  Input,
  Radio,
  Divider,
  Icon, Dimmer, Loader, Segment
} from "semantic-ui-react";
import Role from "../../../enums/role";
import { Common } from "../../../common/common";
import ToastHelper from "../../../helpers/toast.helper";
import { CustomHeaderLabel2 } from "../../../components/labels/labels";
import { connect } from "react-redux";
import * as actions from "../help-me.action";
import { createValidation, validateField } from "../../../validator/validator";
import _ from "lodash";
import { toast } from 'react-semantic-toasts';
import { scanFile } from '../../order/combination/existing-combination-labels.action';

const rules = [];

class HelpMeMessage extends Component {
  state = {
    activeIndex: 0,
    isLoading: "",
    isUploading: false,
    recipientType: "1",
    sourceData: null,
    fileName: "",
    disableTextbox: false,
  };

  componentDidMount() {
    this.props.clearFormOnly();
  }

  toggle = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  handleChange = (e) => {
    let { form } = this.props.helpMe;

    const newState = validateField(rules, form, e.target.name, e.target.value);
    this.props.updateForm(newState);
  };

  handleUploadFile = (event) => {
    const { form } = this.props.helpMe;

    if (event.target.files.length > 0) {
      this.setState({ isUploading: true });
      const file = event.target.files[0];
      const fileSize = file.size / 1024 / 1024;

      if (file.size <= 10485760) {
        var extention = file.name.split('.').pop();

        if (
          extention === 'docx' ||
          extention === 'doc' ||
          extention === 'pdf' ||
          extention === 'jpg' ||
          extention === 'txt' ||
          extention === 'xls' ||
          extention === 'xlsx'
        ) {
          var fileReader = new FileReader();
          var that = this;

          //this.updateForm("fileName", file.name);

          fileReader.onload = function (fileLoadedEvent) {
            var srcData = fileLoadedEvent.target.result;
           
            that.props.scanFile({
                 fileDetails: srcData,
                          })
                          .then(result => {

                            if (result.isSuccessful) {
                               that.setState({ isUploading: false })
                               that.setState({ sourceData: srcData });
                               that.setState({ fileName: file.name });
                              
                               form.attachmentNames += "," + file.name + ",";                              
                               form.attachmentNames = form.attachmentNames.replace(/,\s*$/, "");  
                               form.attachmentNames = form.attachmentNames.replace(/^\s*,/, "");

                               form.sourceData += srcData + ",";

                               const newState = validateField(rules, form, "attachmentNames", form.attachmentNames);
                               that.props.updateForm(newState);
                            } else {
                              setTimeout(() => {
                                toast({
                                  title: '',
                                  description: (
                                    <p>
                                      {
                                        'Virus or malware has been detected, this file cannot be uploaded.'
                                      }
                                    </p>
                                  ),
                                  time: 10000,
                                  size: 'small',
                                  icon: 'check',
                                  color: 'red',
                                });
                              }, 100);
                              this.setState({ isUploading: true });
                            }
                          });
          };
          fileReader.readAsDataURL(file);
        } else {
          setTimeout(() => {
            toast({
              title: '',
              description: (
                <p>{'Only PDF, JPG, JPEG. Word, Excel document types are accepted.'}</p>
              ),
              time: 10000,
              size: 'small',
              icon: 'check',
              color: 'red',
            });
          }, 100);
           this.setState({ isUploading: true });
        }
      } else {
        setTimeout(() => {
          toast({
            title: '',
            description: <p>{'Max. size for each document is 10 MB'}</p>,
            time: 10000,
            size: 'small',
            icon: 'check',
            color: 'red',
          });
        }, 100);
         this.setState({ isUploading: true });
      }
    }
  };

  handleSendMessage = () => {
    this.setState({ isLoading: "loading" });
    const { orderDetails } = this.props;
    const { form, data , userPsn} = this.props.helpMe;
    const { recipientType, sourceData, fileName } = this.state;
    const userId = Common.getUserId();
    let helpMeWithReferenceId = orderDetails.helpMes.find(
      (h) => h.referenceId != null
    );

    form.validationErrors = createValidation(form, rules);

    if (_.isEmpty(form.validationErrors)) {
      const param = {
        message: form.helpMeMessage,
        fileName: fileName,
        labelCenter: orderDetails.labelCenterName,
        userId:
          Common.getUserRole() == Role.labelCenter
            ? (orderDetails || {}).createdById
            : parseInt(userId),
        recipientType: orderDetails.labelOrderType == 1 ? "1" : recipientType,
        artWorkLink: form.sourceData,
        fileName: form.attachmentNames,
        // Customer: save userId, Admin: save userId of customer who created the order
      };

      if (form.cartOrderNo == "cart" || this.props.isCart) {
        param.cartId = orderDetails.id;
      } else {
        param.orderId = orderDetails.id;
      }

        this.props.createMessage(param).then((s) => {
        if (s && (s != null || s != "")) {
          if (s.isSuccessful) {        
             var data = {
                    LabelOrderId: orderDetails.id,
                    ArtWorkLink: form.sourceData,
                    FileName: form.attachmentNames,
                    IsHelpMe: true
                  };
  
            this.props.uploadLabelOrderAttachment(data).then(s => {
                    if (s && s.isSuccess) {
                      setTimeout(() => {
                        ToastHelper.success({
                          title: "Success",
                          description: s.message
                        });
                      }, 100);

                      this.props.getLabelOrder();
                      this.setState({ isLoading: "" });
                      this.props.clearFormOnly();
                      return;
                    }
                    else
                    {  
                      if (s)
                      {
                        setTimeout(() => {
                          ToastHelper.error({
                            title: "Error",
                            // description: "Something went wrong"
                            description: s.message
                          });
                        }, 100);
                        this.setState({ isLoading: "" });
                        return;
                      }
                      else
                      {
                        this.props.getLabelOrder();
                        this.setState({ isLoading: "" });
                      }
                    }
                    
                  }
                 )
                }           
              }
            })
    }
  }

  handleRadioChange = (e, { value }) => {
    this.setState({ recipientType: value });
  };

  render() {
    const { isLoading, recipientType, disableTextbox, isUploading } = this.state;
    const { data, orderDetails, userPsn } = this.props;
    const { form } = this.props.helpMe;
    const translations = Common.getTranslations() || {};
    let printerUserId = 0;
    let customerUserId = 0;

    if (data.length > 0) {
      data.forEach((item) => {
        if (item.helpMe.length > 0) {
          let printerId = item.helpMe.find((h) => h.roleId == 12)?.userId;
          let customerId = item.helpMe.find(
            (h) => h.roleId == 1 || h.roleId == 2
          )?.userId;

          if (printerId) printerUserId = printerId;
          if (customerId) customerUserId = customerId;
        }
      });
    }
  
    return (
      <Fragment>
        <Grid style={{ padding: "0px 25px 25px 25px" }}>
           { isUploading ? (
          <Grid.Column width={16}> {/* Or adjust width as needed */}
            <Segment style={{ minHeight: '200px' }}> {/* Provide height for the loader */}
              <Dimmer active inverted>
                <Loader inverted content='Uploading...' />
              </Dimmer>
            </Segment>
          </Grid.Column>
        ) :
        (         
          <><Grid.Row>
                <Grid.Column>
                  <CustomHeaderLabel2 message={translations["LexHelpMe"]} />
                </Grid.Column>
              </Grid.Row><Grid.Row>
                  <Grid.Column>
                    <Grid>
                      {data.length > 0 ? (
                        <Grid.Row>
                          <Grid.Column>
                            <Card fluid>
                              <Card.Content>
                                <Feed>
                                  {(Common.getUserRole() == Role.labelCenter ||
                                    Common.getUserRole() == Role.labelManager) &&
                                    orderDetails.labelOrderType == 2 ? (
                                    <Fragment>
                                      <fieldset
                                        style={{
                                          paddingLeft: "50px",
                                          paddingRight: "60px"
                                        }}
                                      >
                                        <legend>
                                          <b>Customer</b>
                                        </legend>

                                        {data.map((hm, idx) => (
                                          <Fragment key={idx}>
                                            {hm &&
                                              hm.helpMe &&
                                              hm.helpMe.length > 0 && (
                                                <Grid>
                                                  <Grid.Row>
                                                    <Grid.Column width={3}>
                                                      {hm.dateCreatedString}
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                  <Grid.Row>
                                                    <Grid.Column>
                                                      <table
                                                        className="details-table"
                                                        style={{ width: "100%" }}
                                                      >
                                                        {hm &&
                                                          hm.helpMe
                                                            .filter(
                                                              (h) => (h.userId ==
                                                                customerUserId ||
                                                                h.createdById ==
                                                                customerUserId) &&
                                                                (h.roleId ==
                                                                  Role.applicant ||
                                                                  h.roleId ==
                                                                  Role.manufacturer)
                                                            )
                                                            .map((msg) => (
                                                              <tr>
                                                                <td
                                                                  style={{
                                                                    width: "20%"
                                                                  }}
                                                                >
                                                                  <b>
                                                                    {msg.displayName}
                                                                  </b>
                                                                </td>
                                                                <td
                                                                  style={{
                                                                    width: "auto"
                                                                  }}
                                                                >
                                                                  <b>
                                                                    {msg.message}
                                                                  </b>
                                                                </td>
                                                                <td>

                                                                   {msg && msg.attachmentNames && (
                                                                   <>
                                                                   {"Attachment: "}
                                                                   {msg.attachmentNames.split(",").map((name, index) => {
                                                                   const urls = msg.attachmentUrl ? msg.attachmentUrl.split(",") : [];
                                                                   const url = urls[index]?.trim();
                                                                    return url ? (
                                                                   <a key={index} href={url.startsWith("http") ? url : `https://${url}`} target="_blank" rel="noopener noreferrer">
                                                                    {name.trim()}
                                                                   </a>
                                                                   ) : (
                                                                    <span key={index}>{name.trim()}</span>
                                                                   );
                                                                  }).reduce((prev, curr) => prev === null ? [curr] : [prev, ", ", curr], null)}
                                                                  </>
                                                                   )}
                                                                </td>
                                                              </tr>
                                                            ))}
                                                      </table>
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                  <Grid.Row>
                                                    <Grid.Column>
                                                      <div
                                                        style={{
                                                          border: "1px solid #DCDEE1"
                                                        }}
                                                      ></div>
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                </Grid>
                                              )}
                                          </Fragment>
                                        ))}
                                      </fieldset>
                                      <fieldset
                                        style={{
                                          paddingLeft: "50px",
                                          paddingRight: "60px"
                                        }}
                                      >
                                        <legend>
                                          <b>Printer</b>
                                        </legend>

                                        {data.map((hm, idx) => (
                                          <Fragment key={idx}>
                                            {hm &&
                                              hm.helpMe &&
                                              hm.helpMe.length > 0 && (
                                                <Grid>
                                                  <Grid.Row>
                                                    <Grid.Column width={3}>
                                                      {hm.dateCreatedString}
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                  <Grid.Row>
                                                    <Grid.Column>
                                                      <table
                                                        className="details-table"
                                                        style={{ width: "50%" }}
                                                      >
                                                        {hm &&
                                                          hm.helpMe
                                                            .filter(
                                                              (h) =>
                                                                // (h.userId ==
                                                                //   printerUserId ||
                                                                //   h.createdById ==
                                                                //     printerUserId) &&
                                                                h.roleId ==
                                                                Role.printer
                                                            )
                                                            .map((msg) => (
                                                              <tr>
                                                                <td
                                                                  style={{
                                                                    width: "20%"
                                                                  }}
                                                                >
                                                                  <b>
                                                                    {msg.displayName}
                                                                  </b>
                                                                </td>
                                                                 <td
                                                                  style={{
                                                                    width: "auto"
                                                                  }}
                                                                >
                                                                  <b>
                                                                    {msg.message}
                                                                  </b>
                                                                </td>
                                                                <td>

                                                                   {msg && msg.attachmentNames && (
                                                                   <>
                                                                   {"Attachment: "}
                                                                   {msg.attachmentNames.split(",").map((name, index) => {
                                                                   const urls = msg.attachmentUrl ? msg.attachmentUrl.split(",") : [];
                                                                   const url = urls[index]?.trim();
                                                                    return url ? (
                                                                   <a key={index} href={url.startsWith("http") ? url : `https://${url}`} target="_blank" rel="noopener noreferrer">
                                                                    {name.trim()}
                                                                   </a>
                                                                   ) : (
                                                                    <span key={index}>{name.trim()}</span>
                                                                   );
                                                                  }).reduce((prev, curr) => prev === null ? [curr] : [prev, ", ", curr], null)}
                                                                  </>
                                                                   )}
                                                                </td>
                                                              </tr>
                                                            ))}
                                                      </table>
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                  <Grid.Row>
                                                    <Grid.Column>
                                                      <div
                                                        style={{
                                                          border: "1px solid #DCDEE1"
                                                        }}
                                                      ></div>
                                                    </Grid.Column>
                                                  </Grid.Row>
                                                </Grid>
                                              )}
                                          </Fragment>
                                        ))}
                                      </fieldset>
                                    </Fragment>
                                  ) : (
                                    data.map((hm, idx) => (
                                      <Fragment key={idx}>
                                        {hm && hm.helpMe && hm.helpMe.length > 0 && (
                                          <Grid>
                                            <Grid.Row>
                                              <Grid.Column width={3}>
                                                {hm.dateCreatedString}
                                              </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                              <Grid.Column>
                                                <table
                                                  className="details-table"
                                                  style={{ width: "50%" }}
                                                >
                                                  {hm &&
                                                    hm.helpMe.map((msg) => (
                                                      <tr>
                                                        <td style={{ width: "20%" }}>
                                                          <b>{msg.displayName}</b>
                                                        </td>
                                                         <td
                                                                  style={{
                                                                    width: "auto"
                                                                  }}
                                                                >
                                                                  <b>
                                                                    {msg.message}
                                                                  </b>
                                                                </td>
                                                                <td>

                                                                   {msg && msg.attachmentNames && (
                                                                   <>
                                                                   {"Attachment: "}
                                                                   {msg.attachmentNames.split(",").map((name, index) => {
                                                                   const urls = msg.attachmentUrl ? msg.attachmentUrl.split(",") : [];
                                                                   const url = urls[index]?.trim();
                                                                    return url ? (
                                                                   <a key={index} href={url.startsWith("http") ? url : `https://${url}`} target="_blank" rel="noopener noreferrer">
                                                                    {name.trim()}
                                                                   </a>
                                                                   ) : (
                                                                    <span key={index}>{name.trim()}</span>
                                                                   );
                                                                  }).reduce((prev, curr) => prev === null ? [curr] : [prev, ", ", curr], null)}
                                                                  </>
                                                                   )}
                                                                </td>
                                                      </tr>
                                                    ))}
                                                </table>
                                              </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                              <Grid.Column>
                                                <div
                                                  style={{
                                                    border: "1px solid #DCDEE1"
                                                  }}
                                                ></div>
                                              </Grid.Column>
                                            </Grid.Row>
                                          </Grid>
                                        )}
                                      </Fragment>
                                    ))
                                  )}

                                  <Divider hidden />
                                  <Grid>
                                    <Grid.Row>
                                      <Grid.Column
                                        width={(Common.getUserRole() == Role.labelCenter ||
                                          Common.getUserRole() ==
                                          Role.labelManager) &&
                                          orderDetails.labelOrderType == 2
                                          ? 4
                                          : 2}
                                      >
                                        <Form>
                                          <Form.Group widths="equal">
                                            <Form.Field>
                                              <Button
                                                secondary
                                                basic
                                                size="small"
                                                floated="left"
                                                onClick={this.handleSendMessage}
                                                className={isLoading}
                                                disabled={form.helpMeMessage ? false : true}
                                              >
                                                {Common.getUserRole() !=
                                                  Role.labelCenter
                                                  ? translations["LexSendMessage"]
                                                  : "Send Comment"}
                                              </Button>
                                            </Form.Field>
                                            <Form.Field>
                                              <input
                                                type="file"
                                                id="file"
                                                accept=".pdf,.doc,.docx,.jpg"
                                                style={{ display: 'none' }}
                                                onChange={this.handleUploadFile}
                                                ref={fileInput => (this.fileInput = fileInput)}
                                                hidden="true" />
                                              <Button
                                                secondary
                                                basic
                                                size='mini'
                                                onClick={() => this.fileInput.click()}
                                                className="ui primary button"
                                                style={{ textAlign: 'center' }}
                                              >
                                                <Icon name='attach'></Icon>
                                              </Button>
                                            </Form.Field>
                                            <Form.Field>     </Form.Field>
                                            {(Common.getUserRole() ==
                                              Role.labelCenter ||
                                              Common.getUserRole() ==
                                              Role.labelManager) &&
                                              orderDetails.labelOrderType == 2 && (
                                                <Form.Field>
                                                  <Radio
                                                    label="Send to Customer"
                                                    name="radioGroup"
                                                    value="1"
                                                    checked={recipientType === "1"}
                                                    onChange={this.handleRadioChange} />
                                                  <Divider hidden fitted />
                                                  <Form.Field>
                                                    <Radio
                                                      label="Send to Printer"
                                                      name="radioGroup"
                                                      value="2"
                                                      checked={recipientType === "2"}
                                                      onChange={this.handleRadioChange} />
                                                  </Form.Field>
                                                </Form.Field>
                                              )}
                                          </Form.Group>
                                        </Form>
                                      </Grid.Column>
                                      <Grid.Column width={11}>
                                        <Form.Field
                                          control={Input}
                                          name="helpMeMessage"
                                          onChange={this.handleChange.bind(this)}
                                          value={form && form.helpMeMessage}
                                          maxLength="500"
                                          autoFocus
                                          disabled={Common.getUserRole() ==
                                            Role.fieldEngineerRO} />
                                      </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                      <Grid.Column width={1}><label>Attachments:</label></Grid.Column>
                                      <Grid.Column width={10}>
                                        <label name="attachmentNames">{form && form.attachmentNames}</label>
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>
                                </Feed>
                              </Card.Content>
                            </Card>
                          </Grid.Column>
                        </Grid.Row>
                      ) : (
                        <Grid.Row>
                          <Grid.Column>
                            <Fragment>
                              <Message
                                compact
                                info
                                icon="sticky note outline"
                                header={form && form.cartOrderNo == "cart"
                                  ? "Cart doesn't have comment"
                                  : translations["LexOrderdoesnothavecomment"]} />
                              <Grid>
                                <Grid.Row>
                                  <Grid.Column
                                    width={(Common.getUserRole() == Role.labelCenter ||
                                      Common.getUserRole() == Role.labelManager) &&
                                      orderDetails.labelOrderType == 2
                                      ? 4
                                      : 2}
                                  >
                                    <Form>
                                      <Form.Group widths="equal">
                                        <Form.Field>
                                          <Button
                                            secondary
                                            basic
                                            size="small"
                                            floated="left"
                                            onClick={this.handleSendMessage}
                                            className={isLoading}
                                            disabled={form.helpMeMessage ? false : true}
                                          >
                                            {Common.getUserRole() != Role.labelCenter
                                              ? translations["LexSendMessage"]
                                              : "Send Comment"}
                                          </Button>
                                        </Form.Field>
                                        <Form.Field>
                                          <input
                                            type="file"
                                            id="file"
                                            accept=".pdf,.doc,.docx,.jpg"
                                            style={{ display: 'none' }}
                                            onChange={this.handleUploadFile}
                                            ref={fileInput => (this.fileInput = fileInput)}
                                            hidden="true" />
                                          <Button
                                            secondary
                                            basic
                                            size='mini'
                                            onClick={() => this.fileInput.click()}
                                            className="ui primary button"
                                            style={{ textAlign: 'center' }}
                                          >
                                            <Icon name='attach'></Icon>
                                          </Button>
                                        </Form.Field>
                                        {(Common.getUserRole() == Role.labelCenter ||
                                          Common.getUserRole() ==
                                          Role.labelManager) &&
                                          orderDetails.labelOrderType == 2 && (
                                            <Form.Field>
                                              <Radio
                                                label="Send to Customer"
                                                name="radioGroup"
                                                value="1"
                                                checked={recipientType === "1"}
                                                onChange={this.handleRadioChange} />
                                              <Divider hidden fitted />
                                              <Form.Field>
                                                <Radio
                                                  label="Send to Printer"
                                                  name="radioGroup"
                                                  value="2"
                                                  checked={recipientType === "2"}
                                                  onChange={this.handleRadioChange} />
                                              </Form.Field>
                                            </Form.Field>
                                          )}
                                      </Form.Group>
                                    </Form>
                                  </Grid.Column>
                                  <Grid.Column width={11}>
                                    <Form.Field
                                      control={Input}
                                      name="helpMeMessage"
                                      onChange={this.handleChange.bind(this)}
                                      value={form && form.helpMeMessage}
                                      maxLength="500"
                                      autoFocus
                                      disabled={Common.getUserRole() == Role.fieldEngineerRO} />
                                  </Grid.Column>
                                </Grid.Row>
                                 <Grid.Row>
                                      <Grid.Column width={1}><label>Attachments:</label></Grid.Column>
                                      <Grid.Column width={10}>
                                        <label name="attachmentNames">{form && form.attachmentNames}</label>
                                      </Grid.Column>
                                    </Grid.Row>
                              </Grid>
                            </Fragment>
                          </Grid.Column>
                        </Grid.Row>
                      )}
                    </Grid>
                  </Grid.Column>
                </Grid.Row></>
        )}
        </Grid>
      </Fragment>
    );
 }
}

HelpMeMessage.propTypes = {
  data: PropTypes.array.isRequired,
  orderDetails: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  return {
    loading: state.helpMe.loading,
    isSuccess: state.helpMe.isSuccess,
    helpMe: state.helpMe
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createMessage: (data) => dispatch(actions.createMessage(data)),
    updateForm: (result) => dispatch(actions.updateForm(result)),
    clearForm: (result) => dispatch(actions.clearForm(result)),
    doAddMessage: (params) => dispatch(actions.doAddMessage(params)),
    clearFormOnly: () => dispatch(actions.clearFormOnly()),
    scanFile: data => dispatch(scanFile(data)),
    uploadLabelOrderAttachment: (data) =>
        dispatch(actions.uploadLabelOrderAttachment(data)), 
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(HelpMeMessage));
